exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-tlist[data-v-68e5f5bb] {\n  border: none;\n}", ""]);

// exports
